export function RLSecurityTableCell() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/security-table-cell.html"),
        scope: {
            rightFlag: "=",
            rightStatus: "=",
            description: "=",
            toggle: "&"
        }
    };
    return directive;
}

interface IRLSecurityTableCellScope extends ng.IScope {
    rightFlag: number;
    description: string;
    rightStatus: number;
    toggle: ({ rightFlag: number }) => void
}

